@if (totalPages > 1 || hasTotalItems) {
  <nav class="pagination" aria-label="Paginacion de resultados">
    @if (hasTotalItems) {
      <p class="pagination__summary">
        @if (totalItems === 0) {
          Sin {{ itemLabel }}
        } @else {
          Mostrando {{ startItem }}-{{ endItem }} de {{ totalItems }} {{ itemLabel }}
        }
      </p>
    }

    @if (totalPages > 1) {
      <div class="pagination__controls">
        <button
          type="button"
          class="pagination__action"
          [disabled]="!hasPrevPage"
          aria-label="Pagina anterior"
          (click)="previous()"
        >
          <i class="fa-solid fa-chevron-left" aria-hidden="true"></i>
          <span>Anterior</span>
        </button>

        <div class="pagination__pages">
          @for (item of visiblePages; track item) {
            <button
              type="button"
              class="pagination__page"
              [class.is-active]="item === page"
              [attr.aria-current]="item === page ? 'page' : null"
              (click)="goToPage(item)"
            >
              {{ item }}
            </button>
          }
        </div>

        <button
          type="button"
          class="pagination__action"
          [disabled]="!hasNextPage"
          aria-label="Pagina siguiente"
          (click)="next()"
        >
          <span>Siguiente</span>
          <i class="fa-solid fa-chevron-right" aria-hidden="true"></i>
        </button>
      </div>
    }
  </nav>
}


